export const COLORS = Object.freeze({
  orange: "#EF7D00",
  orangeHover: "#E87800",
  red: "#B42318",
  redInk: "#B42318",
  blue: "#2B6870",
  blueInk: "#2B6870",
  surfaceTeal: "#3C8F99",
  lightBlue: "#88CDD3",
  ink: "#203033",
  muted: "#304346",
  paper: "#FFFAF4",
  line: "rgba(32, 48, 51, 0.14)",
  shadow: "0 16px 36px rgba(32, 48, 51, 0.12)",
  shadowSoft: "0 10px 28px rgba(32, 48, 51, 0.1)",
  badgeOrangeShadow: "0 10px 24px rgba(239, 125, 0, 0.24)",
  badgeBlueShadow: "0 10px 24px rgba(60, 143, 153, 0.24)",
});
